export default __webpack_public_path__ + "static/media/speciality_id_7.ceeb5955.png";